/**
 * applyInsiResolution — augment a patient-record payload with a confirmed INSi
 * resolution, shared by the create flow (T08) and the edit re-search (T09).
 *
 * It clears the legacy free-text `ins` (INS is only ever set via INSi — D1),
 * sets the official `insIdentifier`, copies the authoritative identity traits
 * (name / gender / birth date) onto the record, and attaches the one-shot
 * identity-document attestation when a document was attested (→ QUALIFIEE).
 */
import { insiTraitsToName, insiSexeToGender } from './insiIdentityMapping';

export const applyInsiResolution = (
  record,
  { insIdentifier, traits, attestationDocType } = {}
) => {
  const next = {
    ...record,
    ins: undefined,
    insIdentifier: insIdentifier
      ? { value: insIdentifier.value, type: insIdentifier.type }
      : record.insIdentifier,
  };

  if (traits) {
    next.name = insiTraitsToName(traits);
    next.gender = insiSexeToGender(traits.sexe);
    next.birthDate = traits.dateNaissance || record.birthDate;
  }

  if (attestationDocType) {
    next.identityDocumentAttestation = { documentType: attestationDocType };
  }

  return next;
};

export default applyInsiResolution;
